import React from 'react';
import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';

import {
  useEventState,
  useEventActions,
} from './EventContext';

import styles from './EventTitle.module.scss';

const EventTitle = () => {
  const state = useEventState();
  const { updateTitle, updateShortDescription } = useEventActions();

  const presentationMode = () => {
    return state?.loading ? (
      <p className={styles.title}>Loading...</p>
    ) : (
      <p className={styles.title}>{state?.event?.title}</p>
    );
  };

  const editMode = () => {
    return (
      <Form>
        <Field label="Event Title">
          <Input
            type="text"
            placeholder="Event Title Here..."
            value={state?.event?.title || ''}
            onChange={(e) => updateTitle(e.target.value)}
          />
        </Field>
        <Field label="Short Description">
          <Input
            type="text"
            placeholder="Event Short Description Here..."
            value={state?.event?.shortDescription || ''}
            onChange={(e) => updateShortDescription(e.target.value)}
          />
        </Field>
      </Form>
    );
  };

  return (
    <div className={styles.event}>
      {state?.inEditMode ?
        (
          editMode()
        ) : (
          presentationMode()
        )
      }
    </div>
  );
};

export default EventTitle;
